import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const GrainBalance = ({ grainBalance }) => (
  <React.Fragment>
    <h3 className="title">Grain balance</h3>
    Farmers: <span
    className={grainBalance.production > 0 ? "positive" : undefined}>{formatNumberForceSigned(grainBalance.production)}</span><br/>
    Food production: <span
    className={grainBalance.consumption > 0 ? "negative" : undefined}>{formatNumberForceSigned(-grainBalance.consumption)}</span>
    <br/>
    <LimitLine
      amount={grainBalance.limit.amount}
      limit={grainBalance.limit.limit}
      market={grainBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  grainBalance: state.governorate.resourceBalances.grain,
});

export default connect(mapStateToProps)(GrainBalance);
